/**
 * 每日精选接口封装
 * 对应后端：mplat-admin AiPushSelectedController（/aiPushSelected/*，全部免 token）
 *
 * 路径策略（对齐 aiPush.js）：
 * - 前端统一用 /api/xxx 相对路径
 * - 开发环境：vue.config.js devServer.proxy 把 /api 转发到后端
 * - 生产环境：nginx 反向代理
 * - 缓存由后端 Redis 处理，前端不做缓存
 */
const BASE = '/api/aiPushSelected'

// ── 请求封装 ──────────────────────────────
async function post(path, body = {}) {
  const resp = await fetch(BASE + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {})
  })
  if (!resp.ok) {
    throw new Error(`HTTP ${resp.status} ${resp.statusText}`)
  }
  const json = await resp.json()
  if (json.code !== 0) {
    throw new Error(json.msg || '请求失败')
  }
  return { data: json.data, total: json.total }
}

// ── 接口 ──────────────────────────────────

/** 1. 推送/更新当日精选（幂等 upsert） */
export function upsert(payload) {
  return post('/upsert', payload)
}

/** 2. 批量推送（初始化导入） */
export function batchUpsert(items) {
  return post('/batchUpsert', { items })
}

/** 3. 按日期查当日精选（返回 items 已解析为 List） */
export function getByDate(pushDate) {
  return post('/getByDate', { push_date: pushDate })
}

/** 4. 分页查询列表（日期区间） */
export function list({ startDate, endDate, page = 1, size = 10 } = {}) {
  return post('/list', { startDate, endDate, page, size })
}

/** 5. 日期导航列表（前端日期 pill/下拉框） */
export function dateList(limit = 60) {
  return post('/dateList', { limit })
}

/** 6. 软删某天精选 */
export function remove(pushDate) {
  return post('/delete', { push_date: pushDate })
}

export default {
  upsert, batchUpsert, getByDate, list, dateList, remove
}
